import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=dd1238e4&scoped=true&"
import script from "./FilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./FilterDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./FilterDropdown.vue?vue&type=style&index=0&id=dd1238e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1238e4",
  null
  
)

export default component.exports